import React, {FC, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {useMediaQuery} from 'react-responsive';
import {Link, navigate} from 'gatsby';

import {cleanURL} from '../../helpers';

import Button from '../button';
import Section from '../section';
import {Carousel} from '../slider';
import DemoCta from '../request-demo-cta';
import Layout from '../layout/layout';
import WorkflowCard from '../public-workflows/workflow-card';
import AutomationCards from '../automation/automation-cards';
import TrustedSection from '../trusted-section';

import homeMailImgLg from '../../images/home/illustrations/web-scraping-automation.png';
import homeMailImgSm from '../../images/home/illustrations/web-scraping-automation-sm.png';

import TrustedBusinesses from '../../images/home/testimonials/trusted-by.png';

import ScrapeLg from '../../images/home/illustrations/spreadsheet.png';
import ScrapeSm from '../../images/home/illustrations/spreadsheet-sm.png';

import api from '../../images/home/integrations/api.png';
import sql from '../../images/home/integrations/sql.png';
import slack from '../../images/home/integrations/slack.png';
import google from '../../images/home/integrations/gmail.png';
import webhook from '../../images/home/integrations/webhook.png';
import telegram from '../../images/home/integrations/telegram.png';
import wordpress from '../../images/home/integrations/wordpress.png';
import googleDrive from '../../images/home/integrations/google-drive.png';
import googleSheetsExport from '../../images/home/integrations/google-export.png';
import googleSheetsImport from '../../images/home/integrations/google-import.png';

import left from '../../images/home/left.svg';
import right from '../../images/home/right.svg';
import ai1 from '../../images/home/illustrations/ai-1.png';
import ai2 from '../../images/home/illustrations/ai-2.png';
// import VirtualAssistantSm from '../../images/home/illustrations/virtual-assistant-sm.png';

import gq from '../../images/home/testimonials/gq.png';
import hunt from '../../images/home/testimonials/hunt.png';
import getapp from '../../images/home/testimonials/getapp.png';
import capterra from '../../images/home/testimonials/capterra.png';


import './styles.scss';
import {arrowRight, arrowRightIcon} from '../../images/svgIcons';
import { openCalendly } from '../../helpers/trackingEvents';

const automations = [
  {
    id: 104,
    name: 'Article scraper',
    is_new: false,
    containedPublicWorkflows: [],
    prices: [
      {
        id: 95,
        unit_name: 'request',
        credit_price: 2,
        premium_credit_price: 0,
      },
    ],
    url: 'article-curator',
    meta_title: 'Article Scraper | Article Curator',
    meta_description:
      "Hexomatic's article scraper allows you to extract news article description, keywords, summary and image.",
    short_description: 'Extract news article description, keywords and summary',
    long_description: 'Provide an article URL and extract description, keywords, summary and article image.',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/article-curator.svg',
    category: {
      id: 10,
      name: 'Actions',
    },
    type: {
      id: 4,
      name: 'Built-in automations',
    },
    inputs: 'url',
    outputs:
      '{"_article_curator_title":"text","_article_curator_text":"text","_article_curator_top_image":"url","_article_curator_date":"number","_article_curator_author":"text","_article_curator_description":"text","_article_curator_keyword":"text"}',
    active: true,
    rate: 4.1,
  },
  {
    id: 61,
    name: 'Email Address Validation',
    is_new: false,
    containedPublicWorkflows: [
      {
        public_workflow_id: 29,
        public_workflow_name: 'Find resources page SEO opportunities',
        public_workflow_description:
          'Find curated lists that can link to your own website in minutes. This workflow looks for existing resource pages for a specific keyword on Google and finds contact details on autopilot.',
        public_workflow_created_at: '1631710483422',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-search.png',
            automation_name: 'Google Search',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
            automation_name: 'Emails scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
            automation_name: 'Social links scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/phone-number-scraper.svg',
            automation_name: 'Phone number scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
            automation_name: 'Email Address Validation',
          },
        ],
        categories: [
          {
            id: 2,
            name: 'Marketing',
          },
        ],
      },
      {
        public_workflow_id: 49,
        public_workflow_name: 'Discover email addresses for a list of websites',
        public_workflow_description:
          'Accelerate your outreach by automatically finding email contact details for a list of domains.\nThis workflow taps into the web to find and validate email addresses for any website.',
        public_workflow_created_at: '1634284869744',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-discovery.svg',
            automation_name: 'Email discovery',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
            automation_name: 'Email Address Validation',
          },
        ],
        categories: [
          {
            id: 1,
            name: 'Sales',
          },
        ],
      },
      {
        public_workflow_id: 23,
        public_workflow_name: 'Find email addresses and contact details for any domain in bulk',
        public_workflow_description:
          'Find email, social media and phone number contact details for a list of website in minutes.\nThis workflow looks for contact details on each website and on the web, then validates each email on autopilot.',
        public_workflow_created_at: '1631708742988',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
            automation_name: 'Emails scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-discovery.svg',
            automation_name: 'Email discovery',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
            automation_name: 'Email Address Validation',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/phone-number-scraper.svg',
            automation_name: 'Phone number scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
            automation_name: 'Social links scraper',
          },
        ],
        categories: [
          {
            id: 1,
            name: 'Sales',
          },
        ],
      },
      {
        public_workflow_id: 61,
        public_workflow_name: 'Find SEO guest post opportunities',
        public_workflow_description:
          'Find guest post opportunities for any keyword or industry including email and social media profile contact details for each publisher.',
        public_workflow_created_at: '1643206295094',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-search.png',
            automation_name: 'Google Search',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
            automation_name: 'Emails scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
            automation_name: 'Email Address Validation',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
            automation_name: 'Social links scraper',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/phone-number-scraper.svg',
            automation_name: 'Phone number scraper',
          },
        ],
        categories: [
          {
            id: 2,
            name: 'Marketing',
          },
        ],
      },
      {
        public_workflow_id: 17,
        public_workflow_name: 'Verify a list of email addresses',
        public_workflow_description:
          'Email validation verifies if email addresses are current and still working. With our email validation workflow you can improve your email deliverability and prevent email bounces.',
        public_workflow_created_at: '1631708706510',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
            automation_name: 'Email Address Validation',
          },
        ],
        categories: [
          {
            id: 1,
            name: 'Sales',
          },
        ],
      },
    ],
    prices: [
      {
        id: 38,
        unit_name: 'request',
        credit_price: 1,
        premium_credit_price: 0,
      },
    ],
    url: 'email-validation',
    meta_title: 'Validate Email Addresses | Free Email Checker',
    meta_description:
      'Want to increase your email deliverability? This automation will help you validate a list of email addresses to ensure they are safe and deliverable. ',
    short_description: 'Discover validity of an email address',
    long_description:
      'Automatically check whether an email address is valid and deliverable. It validates the email through regex, and then pings the relative MX server. \nReturns: \n> * Unknown - when unable to verify\n> * Valid - verified (existing)\n> * Invalid - verified (not existing) or not an email\n> * Disposable - temporary emails (checking against more than 115k domains)',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
    category: {
      id: 10,
      name: 'Actions',
    },
    type: {
      id: 4,
      name: 'Built-in automations',
    },
    inputs: 'email address',
    outputs: '{"_email_validation":"text"}',
    active: true,
    rate: 4.1,
  },
  {
    id: 97,
    name: 'Pull contacts',
    is_new: false,
    containedPublicWorkflows: [],
    prices: [
      {
        id: 81,
        unit_name: 'request',
        credit_price: 2,
        premium_credit_price: 0,
      },
      {
        id: 91,
        unit_name: 'proxy_unmetered',
        credit_price: 0,
        premium_credit_price: 1e-7,
      },
      {
        id: 92,
        unit_name: 'proxy_premium',
        credit_price: 0,
        premium_credit_price: 1.2e-7,
      },
    ],
    url: 'pull-contacts',
    meta_title: 'Pull Contacts Automation | Contacts Extractor',
    meta_description:
      'Contacts exctrator automation lets you provide a website URL and discover email addresses, phone numbers and social media links found on the page.',
    short_description: 'Pull contact information found on the page',
    long_description:
      'Provide a website URL and discover email addresses, phone numbers and social media links found on the page.',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/pull-contacts.svg',
    category: {
      id: 1,
      name: 'Scraping',
    },
    type: {
      id: 4,
      name: 'Built-in automations',
    },
    inputs: 'url',
    outputs:
      '{"_facebook":"url","_youtube":"url","_snapchat":"url","_twitter":"url","_vkontakte":"url","_telegram":"url","_skype":"url","_linkedin":"url","_angellist":"url","_instagram":"url","_bitbucket":"url","_twitch":"url","_reddit":"url","_flipboard":"url","_steam":"url","_ebay":"url","_vimeo":"url","_soundcloud":"url","_mixcloud":"url","_bandcamp":"url","_flickr":"url","_fotolog":"url","_canva":"url","_disqus":"url","_houzz":"url","_wordpress":"url","_fiverr":"url","_pinterest":"url","_badoo":"url","_medium":"url","_dailymotio":"url","_vine":"url","_quora":"url","_gravatar":"url","_bitly":"url","_behance":"url","_tripadvisor":"url","_dribble":"url","_wattpad":"url","_fanpop":"url","_patreon":"url","_slideshare":"url","_codeacademy":"url","_cybrary":"url","_keybase":"url","_paypal":"url","_instructables":"url","_deviantart":"url","_foursquare":"url","_hubpages":"url","_kongregate":"url","_imgur":"url","_wikipedia":"url","_gamespot":"url","_roblox":"url","_photobucket":"url","_polyvore":"url","_tiktok":"url","_linktree":"url","_linkfolio":"url","_spotify":"url","_campsite":"url","_swipop":"url","_ContactInBio":"url","_discord":"url","_emails":"email address","_phones":"phone number"}',
    active: true,
    rate: 4.1,
  },
  {
    id: 13,
    name: 'Discover Tech Stack',
    is_new: true,
    containedPublicWorkflows: [
      {
        public_workflow_id: 24,
        public_workflow_name: 'Competitor research from a list of domains',
        public_workflow_description:
          'Accelerate your competitor research with this ready made workflow combining WHOIS, tech stack and meta tags reports for a list of websites.',
        public_workflow_created_at: '1631708747779',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-tech-stack.svg',
            automation_name: 'Discover Tech Stack',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-WHOIS.svg',
            automation_name: 'Discover WHOIS',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/seo.svg',
            automation_name: 'SEO meta tags',
          },
        ],
        categories: [
          {
            id: 3,
            name: 'Research',
          },
        ],
      },
      {
        public_workflow_id: 27,
        public_workflow_name: 'Discover tech stack for a list of websites',
        public_workflow_description:
          'Discover the tech stack used on a list of URLs including what type of technology and third-party services are currently in use.',
        public_workflow_created_at: '1631708764503',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-tech-stack.svg',
            automation_name: 'Discover Tech Stack',
          },
        ],
        categories: [
          {
            id: 3,
            name: 'Research',
          },
        ],
      },
    ],
    prices: [
      {
        id: 16,
        unit_name: 'request',
        credit_price: 1,
        premium_credit_price: 0,
      },
    ],
    url: 'discover-tech-stack',
    meta_title: 'Tech Stack Analyzer Automation | Hexomatic',
    meta_description:
      'Our tech stack analyzer automation allows you to find the tech stack used on any page including what type of technology and third-party services are currently in use.',
    short_description: 'Discover the tech stack used on any page',
    long_description:
      'Discover the tech stack used on any page including what type of technology and third-party services are currently in use. It enables you to check for specific tech stack combinations. Ideal for analyzing websites at scale and highlighting the ones using a specific technology or provider.',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-tech-stack.svg',
    category: {
      id: 9,
      name: 'Research',
    },
    type: {
      id: 4,
      name: 'Built-in automations',
    },
    inputs: 'url',
    outputs: '{"_tech_stack":"text"}',
    active: true,
    rate: 4.1,
  },
  {
    id: 14,
    name: 'SEO meta tags',
    is_new: false,
    containedPublicWorkflows: [
      {
        public_workflow_id: 24,
        public_workflow_name: 'Competitor research from a list of domains',
        public_workflow_description:
          'Accelerate your competitor research with this ready made workflow combining WHOIS, tech stack and meta tags reports for a list of websites.',
        public_workflow_created_at: '1631708747779',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-tech-stack.svg',
            automation_name: 'Discover Tech Stack',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/discover-WHOIS.svg',
            automation_name: 'Discover WHOIS',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/seo.svg',
            automation_name: 'SEO meta tags',
          },
        ],
        categories: [
          {
            id: 3,
            name: 'Research',
          },
        ],
      },
      {
        public_workflow_id: 28,
        public_workflow_name: 'Extract meta tags for a list of URLS',
        public_workflow_description:
          'Improve your clickthrough rate in search engines and social networks by extracting meta tags at scale in minutes. This workflow extracts the meta title, description, opengraph and twittergraph  tags for a list of URLs on autopilot.',
        public_workflow_created_at: '1631708770351',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
            automation_name: 'Data input',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/seo.svg',
            automation_name: 'SEO meta tags',
          },
        ],
        categories: [
          {
            id: 2,
            name: 'Marketing',
          },
        ],
      },
      {
        public_workflow_id: 65,
        public_workflow_name: 'Website SEO spelling and grammar audit',
        public_workflow_description:
          'Run an in-depth spelling and grammar audit on any website. This workflow creates branded CSV and Google Sheet reports you can share with your team, prospects, or clients.',
        public_workflow_created_at: '1645169357740',
        steps: [
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/crawler-automation.svg',
            automation_name: 'Crawler',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/seo.svg',
            automation_name: 'SEO meta tags',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/get-words-count.svg',
            automation_name: 'Content analysis',
          },
          {
            automation_icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/grammar-spelling.svg',
            automation_name: 'Grammar & spelling audit',
          },
        ],
        categories: [
          {
            id: 2,
            name: 'Marketing',
          },
        ],
      },
    ],
    prices: [
      {
        id: 23,
        unit_name: 'request',
        credit_price: 1,
        premium_credit_price: 0,
      },
    ],
    url: 'seo-meta-tags',
    meta_title: 'Website Meta Data Extractor | Extract meta tags',
    meta_description:
      'Automate time consuming SEO meta tag research by scraping meta titles, descriptions and more in bulk. No code required.',
    short_description: 'Extract meta tags from any given URL',
    long_description:
      'Get the SEO meta tags used on any page including meta title, description, canonical, robots, opengraph and twitter cards tags.\n\nThese are used by search engines to understand the content of the page as well as to craft the title and description used in the search engine results pages.\n',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/seo.svg',
    category: {
      id: 23,
      name: 'SEO',
    },
    type: {
      id: 4,
      name: 'Built-in automations',
    },
    inputs: 'url',
    outputs:
      '{"_title_tag":"text","_meta_description":"text","_og_image_type":"text","_og_image_width":"number","_og_image_height":"number","_og_locale":"text","_twitter_title":"text","_twitter_description":"text","_twitter_image":"url","_twitter_site":"text","_twitter_creator":"text","_twitter_card":"text","_canonical_tag":"url","_twitter_image_alt":"text","_twitter_player":"url","_keywords":"text","_robots_meta_tag":"text","_og_url":"text","_og_title":"text","_og_description":"text","_og_image":"url","_og_site_name":"text","_og_type":"text"}',
    active: true,
    rate: 4.1,
  },
  {
    id: 143,
    name: 'ChatGPT (GPT-3.5)',
    is_new: true,
    containedPublicWorkflows: [],
    prices: [
      {
        id: 143,
        unit_name: 'request',
        credit_price: 1,
        premium_credit_price: 0.00024,
      },
    ],
    url: 'chatgpt',
    meta_title: 'Summarize or Rewrite Scraped Content | ChatGPT Hexomatic',
    meta_description:
      'Hexomatic integration with ChatGPT (GPT-3.5) will allow you to summarize or rewrite your scraped content just right on your dashboard!',
    short_description: 'Use the power of ChatGPT inside your Hexomatic workflows.',
    long_description:
      'Tap into the power of AI by creating your own prompts to perform ChatGPT tasks on the data you scraped or uploaded, or use our ready-made prompts to summarize, rewrite or improve data inside your workflow.',
    icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/ChatGPT.svg',
    category: {
      id: 21,
      name: 'AI services',
    },
    type: {
      id: 5,
      name: 'Premium automations',
    },
    inputs: 'url',
    outputs: '{"_prompt":"text", "_ChatGPT":"text"}',
    active: true,
    rate: 4.1,
  },
];

const workflows = [
  {
    id: 69,
    name: 'Find B2B leads from Google Maps',
    status: 'DRAFT',
    started_at: '1631705645712',
    frequency: '',
    created_at: '1645536733167',
    updated_at: '1645536733167',
    description:
      'Find local businesses or B2B prospects for any industry and geographic location on autopilot. This workflow enriches every prospect with contact details and social media profiles for easy outreach.',
    meta_title: 'Find local businesses or B2B leads via Google Maps on autopilot - Hexomatic workflow',
    meta_description:
      '<p>Google maps is one of the biggest and freshest sources of local businesses for any location. Unfortunately, this data is typically time consuming to tap into requiring copy pasting information and researching each potential prospect separately.</p>\n<p>With Hexomatic you can run an entire small business or B2B research campaign in minutes - no code or previous experience required.</p>\n<p>This workflow taps into Google Maps to find local businesses for any keyword and location.</p>\n<p>Hexomatic then captures their data and performs research on every website to find email addresses and social media profiles you can use to get in touch.</p>',
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Find%20B2B%20leads%20from%20Google%20Maps.jpg',
    categories: [
      {
        id: 1,
        name: 'Sales',
      },
    ],
    steps: [
      {
        id: 366,
        setting:
          '{"automation_id":31,"dynamic_settings":{"keys":[{"key":null,"settings":{"os":"windows","zoom":"","depth":100,"device":"desktop","save_to":100,"latitude":"","longitude":"","save_from":1,"uniqueHash":"1651246099035","location_code":2840},"inputValue":"Type your search query"}]},"output_keys_data":["_maps_keyword","_maps_rank_group","_maps_rank_absolute","_maps_domain","_maps_title","_maps_url","_maps_snippet","_maps_address","_maps_address_info_borough","_maps_address_info_address","_maps_address_info_city","_maps_address_info_zip","_maps_address_info_region","_maps_address_info_country_code","_maps_rating_type","_maps_rating_value","_maps_rating_votes_count","_maps_rating_rating_max","_maps_place_id","_maps_phone","_maps_main_image","_maps_category","_maps_work_hours","_maps_feature_id","_maps_cid","_maps_latitude","_maps_longitude"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_maps_rank_group\\":\\"number\\",\\"_maps_address_info_city\\":\\"text\\",\\"_maps_address_info_zip\\":\\"number\\",\\"_maps_address_info_region\\":\\"text\\",\\"_maps_address_info_country_code\\":\\"text\\",\\"_maps_rating_type\\":\\"text\\",\\"_maps_rating_value\\":\\"text\\",\\"_maps_rating_votes_count\\":\\"number\\",\\"_maps_rating_rating_max\\":\\"number\\",\\"_maps_place_id\\":\\"text\\",\\"_maps_phone\\":\\"number\\",\\"_maps_rank_absolute\\":\\"number\\",\\"_maps_main_image\\":\\"url\\",\\"_maps_work_hours\\":\\"text\\",\\"_maps_feature_id\\":\\"text\\",\\"_maps_cid\\":\\"number\\",\\"_maps_latitude\\":\\"number\\",\\"_maps_longitude\\":\\"number\\",\\"_maps_domain\\":\\"url\\",\\"_maps_title\\":\\"text\\",\\"_maps_url\\":\\"url\\",\\"_maps_snippet\\":\\"text\\",\\"_maps_address\\":\\"text\\",\\"_maps_address_info_borough\\":\\"text\\",\\"_maps_address_info_address\\":\\"text\\",\\"_maps_keyword\\":\\"text\\",\\"_maps_category\\":\\"text\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 31,
          name: 'Google Maps',
          url: 'google-maps',
          meta_title: 'Google Maps Automation | Hexomatic',
          meta_description:
            'Perform Google Maps searches and get SERP results SERP results via our managed automation. No proxies or scraping required.',
          short_description: 'Perform Google Maps searches and get SERP results',
          long_description:
            'Perform Google Maps searches and get SERP results via our managed automation (0.04 premium credit per query to get 100 search results). No proxies or scraping required.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-maps.svg',
        },
      },
      {
        id: 367,
        setting:
          '{"automation_id":74,"dynamic_settings":{"keys":[{"key":"_maps_domain","settings":{"condition":null,"filter_data":null,"max_results_per_domain":10},"inputValue":null}]},"output_keys_data":["_maps_keyword","_maps_rank_group","_maps_rank_absolute","_maps_domain","_maps_title","_maps_url","_maps_snippet","_maps_address","_maps_address_info_borough","_maps_address_info_address","_maps_address_info_city","_maps_address_info_zip","_maps_address_info_region","_maps_address_info_country_code","_maps_rating_type","_maps_rating_value","_maps_rating_votes_count","_maps_rating_rating_max","_maps_place_id","_maps_phone","_maps_main_image","_maps_category","_maps_work_hours","_maps_feature_id","_maps_cid","_maps_latitude","_maps_longitude","_discovered_email"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_maps_rank_group\\":\\"number\\",\\"_maps_address_info_city\\":\\"text\\",\\"_maps_address_info_zip\\":\\"number\\",\\"_maps_address_info_region\\":\\"text\\",\\"_maps_address_info_country_code\\":\\"text\\",\\"_maps_rating_type\\":\\"text\\",\\"_maps_rating_value\\":\\"text\\",\\"_maps_rating_votes_count\\":\\"number\\",\\"_maps_rating_rating_max\\":\\"number\\",\\"_maps_place_id\\":\\"text\\",\\"_maps_phone\\":\\"number\\",\\"_maps_rank_absolute\\":\\"number\\",\\"_maps_main_image\\":\\"url\\",\\"_maps_work_hours\\":\\"text\\",\\"_maps_feature_id\\":\\"text\\",\\"_maps_cid\\":\\"number\\",\\"_maps_latitude\\":\\"number\\",\\"_maps_longitude\\":\\"number\\",\\"_maps_domain\\":\\"url\\",\\"_maps_title\\":\\"text\\",\\"_maps_url\\":\\"url\\",\\"_maps_snippet\\":\\"text\\",\\"_maps_address\\":\\"text\\",\\"_maps_address_info_borough\\":\\"text\\",\\"_maps_address_info_address\\":\\"text\\",\\"_maps_keyword\\":\\"text\\",\\"_maps_category\\":\\"text\\",\\"_discovered_email\\":\\"email address\\"}"}',
        index: 1,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 74,
          name: 'Email discovery',
          url: 'email-discovery',
          meta_title: 'Find Email Address | Email Finder',
          meta_description: 'Find email addresses for any website in minutes to supercharge your cold email outreach.',
          short_description: 'Discover email addresses found on the website or referenced on the internet',
          long_description:
            'Provide a list of domains and discover email addresses found on the website or referenced on the internet.\nThis automation consumes 0.16 premium credits per verified email.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-discovery.svg',
        },
      },
    ],
    tags: ['Sales'],
  },
  {
    id: 61,
    name: 'Find SEO guest post opportunities',
    status: 'DRAFT',
    started_at: '1631708629322',
    frequency: '',
    created_at: '1643206295094',
    updated_at: '1643206295094',
    description:
      'Find guest post opportunities for any keyword or industry including email and social media profile contact details for each publisher.',
    meta_title: 'Find guest post opportunities to improve your SEO rankings on autopilot - Hexomatic workflow',
    meta_description:
      '<p>Guest posting is an effective promotion strategy to build links and boost your authority. If used properly, guest posting can bring you an SEO boost and expose your products and services to a world of potential customers.</p>\n\n<p>The problem is that finding relevant backlink partners and researching their contact details is time-consuming, involving hours of research and manual work.</p>\n\n<p>With Hexomatic you can look for guest post opportunities in minutes and automate contact detail discovery for each publisher to supercharge your outreach - no tedious research required.</p>\n\n<p>This workflow enables you to specify a keyword and geographic location to find tons of guest post opportunities on autopilot.</p>\n\n<p>Hexomatic will then research contact details for every publisher and provide all the data in a convenient CSV or Google Sheet format.</p>',
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Find%20SEO%20guest%20post%20opportunities.jpg',
    categories: [
      {
        id: 2,
        name: 'Marketing',
      },
    ],
    steps: [
      {
        id: 323,
        setting:
          '{"automation_id":30,"dynamic_settings":{"keys":[{"key":null,"settings":{"depth":100,"device":"desktop","radius":"","save_to":100,"latitude":"","longitude":"","save_from":1,"searchType":"organic","uniqueHash":"1651164621848","location_code":2840},"inputValue":"[pet grooming] + “Write for Us”"}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 30,
          name: 'Google Search',
          url: 'google-search',
          meta_title: 'Scrape Google Search | Hexomatic',
          meta_description:
            'Perform Google searches and get SERP data instantly via our Google search automation. No proxies or scraping recipes are required.',
          short_description: 'Perform Google searches and get SERP data',
          long_description:
            'Perform Google searches and get results via our managed automation (0.04 premium credit per query to get 100 search results). No proxies or scraping recipes required.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-search.png',
        },
      },
      {
        id: 324,
        setting:
          '{"automation_id":6,"dynamic_settings":{"keys":[{"key":"_url","settings":{"proxy":{"type":"","country_code":""},"condition":null,"filter_data":null,"max_results_per_domain":10},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\"}"}',
        index: 1,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 6,
          name: 'Emails scraper',
          url: 'emails-scraper',
          meta_title: 'Email Scraper | Bulk Scrape Emails',
          meta_description:
            'Want to capture emails from any website? The email scraper automation can capture all email addresses found on any web page in minutes.',
          short_description: 'Extract email addresses from any URL',
          long_description: 'Automatically capture all the email addresses published on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
        },
      },
      {
        id: 325,
        setting:
          '{"automation_id":61,"dynamic_settings":{"keys":[{"key":"_email_scraper"}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_email_validation"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_email_validation\\":\\"text\\"}"}',
        index: 2,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 61,
          name: 'Email Address Validation',
          url: 'email-validation',
          meta_title: 'Validate Email Addresses | Free Email Checker',
          meta_description:
            'Want to increase your email deliverability? This automation will help you validate a list of email addresses to ensure they are safe and deliverable. ',
          short_description: 'Discover validity of an email address',
          long_description:
            'Automatically check whether an email address is valid and deliverable. It validates the email through regex, and then pings the relative MX server. \nReturns: \n> * Unknown - when unable to verify\n> * Valid - verified (existing)\n> * Invalid - verified (not existing) or not an email\n> * Disposable - temporary emails (checking against more than 115k domains)',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
        },
      },
      {
        id: 326,
        setting:
          '{"automation_id":7,"dynamic_settings":{"keys":[{"key":"_url","settings":{"media":["_facebook","_youtube","_twitter","_linkedin","_instagram"],"proxy":{"type":"","country_code":""}},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_email_validation","_facebook","_youtube","_twitter","_linkedin","_instagram"],"predefined_settings":{"browser":false},"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_email_validation\\":\\"text\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\"}"}',
        index: 3,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 7,
          name: 'Social links scraper',
          url: 'social-links-scraper',
          meta_title: 'Social Links Scraper | Hexomatic Automation',
          meta_description:
            'This automation automatically captures all the social media profile links found on a given page and help you get the contact details of potential customers.',
          short_description: 'Extract social media profile links from any URL',
          long_description: 'Automatically capture all the social media profile links found on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
        },
      },
      {
        id: 327,
        setting:
          '{"automation_id":76,"dynamic_settings":{"keys":[{"key":"_url","settings":null,"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_email_validation","_facebook","_youtube","_twitter","_linkedin","_instagram","_phone_numbers"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_email_validation\\":\\"text\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\",\\"_phone_numbers\\":\\"number\\"}"}',
        index: 4,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 76,
          name: 'Phone number scraper',
          url: 'phone-number-scraper',
          meta_title: 'Phone Number Scraper | Phone Number Extractor',
          meta_description:
            'Getting the phone numbers of potential customers manually is time-consuming. Learn how to scrape thousands of phone numbers instantly.',
          short_description: 'Extract phone numbers from pages ',
          long_description: 'Automatically find and extract phone numbers from web pages.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/phone-number-scraper.svg',
        },
      },
    ],
    tags: ['Marketing'],
  },
  {
    id: 49,
    name: 'Discover email addresses for a list of websites',
    status: null,
    started_at: '1634284836041',
    frequency: '',
    created_at: '1634284869744',
    updated_at: '1634284869744',
    description:
      'Accelerate your outreach by automatically finding email contact details for a list of domains.\nThis workflow taps into the web to find and validate email addresses for any website.',
    meta_title: 'Find email addresses for any domain in bulk - Hexomatic workflow',
    meta_description:
      "<p>Cold email, or outreach, is one of the most effective methods to get in contact with prospects, influencers who aren't already connected with you. But finding direct contact details is a tedious and time-consuming task.</p>\n\n<p>Did you find the perfect prospect, but can’t find their contact details?</p>\n\n<p>Simply provide a list of domains and Hexomatic will scour the web to find publically available email addresses and validate these to ensure low bounce rates that could affect your email deliverability.</p>",
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Discover%20email%20addresses%20for%20a%20list%20of%20websites.jpg',
    categories: [
      {
        id: 1,
        name: 'Sales',
      },
    ],
    steps: [
      {
        id: 299,
        setting:
          '{"automation_id":47,"dynamic_settings":{"keys":[{"key":null,"settings":{"type":"Structured data","columns":[],"storage":null,"jsonKeys":[],"inputType":"MANUAL_ADD_TYPE","uploadedFiles":[],"workflowUploadId":null},"inputValue":["google.com","yahoo.com"]}]},"output_keys_data":["_data_input"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_data_input\\":\\"any\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 47,
          name: 'Data input',
          url: 'input',
          meta_title: 'Data Input | Hexomatic',
          meta_description:
            'Use our data input automation as a starting point for your workflow. Provide a list of URLs or text files as input for scraping recipes or automation.',
          short_description: 'Provide your workflow with a text or file-based input',
          long_description:
            'Provide a list of URLs, text, or TXT/CSV files inside your workflow as input for scraping recipes or automation.\nThe Data Input automation enables you to provide data as a starting point for your workflow.\n**We currently support four types of data inputs:**\n> * File upload - Lets you upload CSV, TXT, IMAGE, PDF, AUDIO or JSON files.\n> * File URL - Lets you specify the URL of a  CSV and TXT file.\n> * Manual paste - Lets you copy paste a list of URLs or keywords and iterate through each in your workflow. You can also paste blocks of text.\n\nYou can then add additional automations to perform different work tasks for each URL, Keyword or data provided in the data input.\n> * Supported image formats include: .jpeg, .png8, .png24, .png, .gif, .bmp, .webp, .raw, .ico, .jpg.\n> * Supported audio formats include: WAV, MP3, FLAC.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/data-input.svg',
        },
      },
      {
        id: 300,
        setting:
          '{"automation_id":74,"dynamic_settings":{"keys":[{"key":"_data_input"}]},"output_keys_data":["_data_input","_discovered_email"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_data_input\\":\\"any\\",\\"_discovered_email\\":\\"email address\\"}"}',
        index: 1,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 74,
          name: 'Email discovery',
          url: 'email-discovery',
          meta_title: 'Find Email Address | Email Finder',
          meta_description: 'Find email addresses for any website in minutes to supercharge your cold email outreach.',
          short_description: 'Discover email addresses found on the website or referenced on the internet',
          long_description:
            'Provide a list of domains and discover email addresses found on the website or referenced on the internet.\nThis automation consumes 0.16 premium credits per verified email.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-discovery.svg',
        },
      },
      {
        id: 301,
        setting:
          '{"automation_id":61,"dynamic_settings":{"keys":[{"key":"_discovered_email"}]},"output_keys_data":["_data_input","_discovered_email","_email_validation"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_data_input\\":\\"any\\",\\"_discovered_email\\":\\"email address\\",\\"_email_validation\\":\\"text\\"}"}',
        index: 2,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 61,
          name: 'Email Address Validation',
          url: 'email-validation',
          meta_title: 'Validate Email Addresses | Free Email Checker',
          meta_description:
            'Want to increase your email deliverability? This automation will help you validate a list of email addresses to ensure they are safe and deliverable. ',
          short_description: 'Discover validity of an email address',
          long_description:
            'Automatically check whether an email address is valid and deliverable. It validates the email through regex, and then pings the relative MX server. \nReturns: \n> * Unknown - when unable to verify\n> * Valid - verified (existing)\n> * Invalid - verified (not existing) or not an email\n> * Disposable - temporary emails (checking against more than 115k domains)',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
        },
      },
    ],
    tags: ['Sales'],
  },
  {
    id: 29,
    name: 'Find resources page SEO opportunities',
    status: 'DRAFT',
    started_at: '1631710477441',
    frequency: '',
    created_at: '1631710483422',
    updated_at: '1631710483422',
    description:
      'Find curated lists that can link to your own website in minutes. This workflow looks for existing resource pages for a specific keyword on Google and finds contact details on autopilot.',
    meta_title: 'Resource page SEO link building on autopilot - Hexomatic workflow',
    meta_description:
      '<p>Resource page link building is a powerful SEO link-building tactic where you can take advantage of existing curated resource pages that rank in Google.</p>\n\n<p>When someone adds your link to their resource page, your link makes their page better and more authoritative, a win-win for all. That’s because resource pages are designed to link to great content on other websites.</p>\n\n<p>With Hexomatic you can run an entire resource page SEO campaign in minutes - no code or previous experience required.</p>\n\n<p>This workflow taps into Google search to find existing resource pages ranking for a specific keyword or industry.</p>\n\n<p>Hexomatic then performs research on every website to find email addresses and social media profiles you can use to get in touch to add a link to your relevant product or service.</p>',
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Find%20resources%20page%20SEO%20opportunities.jpg',
    categories: [
      {
        id: 2,
        name: 'Marketing',
      },
    ],
    steps: [
      {
        id: 318,
        setting:
          '{"automation_id":30,"dynamic_settings":{"keys":[{"key":null,"settings":{"depth":100,"device":"desktop","radius":"","save_to":100,"latitude":"","longitude":"","save_from":1,"searchType":"organic","uniqueHash":"1651245289329","location_code":2840},"inputValue":"intitle:resources \\"pet grooming\\""}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 30,
          name: 'Google Search',
          url: 'google-search',
          meta_title: 'Scrape Google Search | Hexomatic',
          meta_description:
            'Perform Google searches and get SERP data instantly via our Google search automation. No proxies or scraping recipes are required.',
          short_description: 'Perform Google searches and get SERP data',
          long_description:
            'Perform Google searches and get results via our managed automation (0.04 premium credit per query to get 100 search results). No proxies or scraping recipes required.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-search.png',
        },
      },
      {
        id: 319,
        setting:
          '{"automation_id":6,"dynamic_settings":{"keys":[{"key":"_url","settings":{"proxy":{"type":"","country_code":""},"condition":null,"filter_data":null,"max_results_per_domain":10},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\"}"}',
        index: 1,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 6,
          name: 'Emails scraper',
          url: 'emails-scraper',
          meta_title: 'Email Scraper | Bulk Scrape Emails',
          meta_description:
            'Want to capture emails from any website? The email scraper automation can capture all email addresses found on any web page in minutes.',
          short_description: 'Extract email addresses from any URL',
          long_description: 'Automatically capture all the email addresses published on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
        },
      },
      {
        id: 320,
        setting:
          '{"automation_id":7,"dynamic_settings":{"keys":[{"key":"_url","settings":{"media":["_facebook","_youtube","_twitter","_linkedin","_instagram"],"proxy":{"type":"","country_code":""}},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_facebook","_youtube","_twitter","_linkedin","_instagram"],"predefined_settings":{"browser":false},"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\"}"}',
        index: 2,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 7,
          name: 'Social links scraper',
          url: 'social-links-scraper',
          meta_title: 'Social Links Scraper | Hexomatic Automation',
          meta_description:
            'This automation automatically captures all the social media profile links found on a given page and help you get the contact details of potential customers.',
          short_description: 'Extract social media profile links from any URL',
          long_description: 'Automatically capture all the social media profile links found on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
        },
      },
      {
        id: 321,
        setting:
          '{"automation_id":76,"dynamic_settings":{"keys":[{"key":"_url","settings":null,"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_facebook","_youtube","_twitter","_linkedin","_instagram","_phone_numbers"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\",\\"_phone_numbers\\":\\"number\\"}"}',
        index: 3,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 76,
          name: 'Phone number scraper',
          url: 'phone-number-scraper',
          meta_title: 'Phone Number Scraper | Phone Number Extractor',
          meta_description:
            'Getting the phone numbers of potential customers manually is time-consuming. Learn how to scrape thousands of phone numbers instantly.',
          short_description: 'Extract phone numbers from pages ',
          long_description: 'Automatically find and extract phone numbers from web pages.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/phone-number-scraper.svg',
        },
      },
      {
        id: 322,
        setting:
          '{"automation_id":61,"dynamic_settings":{"keys":[{"key":"_email_scraper"}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_facebook","_youtube","_twitter","_linkedin","_instagram","_phone_numbers","_email_validation"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\",\\"_phone_numbers\\":\\"number\\",\\"_email_validation\\":\\"text\\"}"}',
        index: 4,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 61,
          name: 'Email Address Validation',
          url: 'email-validation',
          meta_title: 'Validate Email Addresses | Free Email Checker',
          meta_description:
            'Want to increase your email deliverability? This automation will help you validate a list of email addresses to ensure they are safe and deliverable. ',
          short_description: 'Discover validity of an email address',
          long_description:
            'Automatically check whether an email address is valid and deliverable. It validates the email through regex, and then pings the relative MX server. \nReturns: \n> * Unknown - when unable to verify\n> * Valid - verified (existing)\n> * Invalid - verified (not existing) or not an email\n> * Disposable - temporary emails (checking against more than 115k domains)',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-validation.svg',
        },
      },
    ],
    tags: ['Marketing'],
  },
  {
    id: 77,
    name: 'Scrape Google Maps to a spreadsheet',
    status: 'completed',
    started_at: '1673948373311',
    frequency: '',
    created_at: '1673948552270',
    updated_at: '1673948552270',
    description:
      'Turn any Google Maps search into a structured spreadsheet. Ideal for researching local businesses at scale.',
    meta_title: 'Scrape Google Maps to a spreadsheet | Hexomatic workflow',
    meta_description:
      '<p>Google maps is one of the most comprehensive directories of local businesses for any location, representing a goldmine of business data. </p>\n\n<p>Unfortunately, Google Maps data is not normally exportable, requiring time-consuming manual data entry to collect leads.</p>\n\n<p>With Hexomatic, you can turn any Google Maps search into a structured spreadsheet. Ideal for researching local businesses at scale.</p>',
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Find%20B2B%20leads%20from%20Google%20Maps.jpg',
    categories: [
      {
        id: 1,
        name: 'Sales',
      },
    ],
    steps: [
      {
        id: 419,
        setting:
          '{"source":{"source_csv":false,"source_txt":false},"automation_id":31,"dynamic_settings":{"keys":[{"key":null,"settings":{"os":"windows","zoom":"","depth":100,"device":"desktop","save_to":100,"latitude":"","longitude":"","save_from":1,"uniqueHash":"1673948365909","location_code":2840},"inputValue":"Sushi in New York"}]},"output_keys_data":["_maps_keyword","_maps_rank_group","_maps_rank_absolute","_maps_domain","_maps_title","_maps_url","_maps_snippet","_maps_address","_maps_address_info_borough","_maps_address_info_address","_maps_address_info_city","_maps_address_info_zip","_maps_address_info_region","_maps_address_info_country_code","_maps_rating_type","_maps_rating_value","_maps_rating_votes_count","_maps_rating_rating_max","_maps_place_id","_maps_phone","_maps_main_image","_maps_category","_maps_work_hours","_maps_feature_id","_maps_cid","_maps_latitude","_maps_longitude"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_maps_rank_group\\":\\"number\\",\\"_maps_address_info_city\\":\\"text\\",\\"_maps_address_info_zip\\":\\"number\\",\\"_maps_address_info_region\\":\\"text\\",\\"_maps_address_info_country_code\\":\\"text\\",\\"_maps_rating_type\\":\\"text\\",\\"_maps_rating_value\\":\\"text\\",\\"_maps_rating_votes_count\\":\\"number\\",\\"_maps_rating_rating_max\\":\\"number\\",\\"_maps_place_id\\":\\"text\\",\\"_maps_phone\\":\\"number\\",\\"_maps_rank_absolute\\":\\"number\\",\\"_maps_main_image\\":\\"url\\",\\"_maps_work_hours\\":\\"text\\",\\"_maps_feature_id\\":\\"text\\",\\"_maps_cid\\":\\"number\\",\\"_maps_latitude\\":\\"number\\",\\"_maps_longitude\\":\\"number\\",\\"_maps_domain\\":\\"url\\",\\"_maps_title\\":\\"text\\",\\"_maps_url\\":\\"url\\",\\"_maps_snippet\\":\\"text\\",\\"_maps_address\\":\\"text\\",\\"_maps_address_info_borough\\":\\"text\\",\\"_maps_address_info_address\\":\\"text\\",\\"_maps_keyword\\":\\"text\\",\\"_maps_category\\":\\"text\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 31,
          name: 'Google Maps',
          url: 'google-maps',
          meta_title: 'Google Maps Automation | Hexomatic',
          meta_description:
            'Perform Google Maps searches and get SERP results SERP results via our managed automation. No proxies or scraping required.',
          short_description: 'Perform Google Maps searches and get SERP results',
          long_description:
            'Perform Google Maps searches and get SERP results via our managed automation (0.04 premium credit per query to get 100 search results). No proxies or scraping required.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-maps.svg',
        },
      },
    ],
    tags: ['Sales'],
  },
  {
    id: 60,
    name: 'Find affiliates for your product or service',
    status: 'DRAFT',
    started_at: '1631708296293',
    frequency: '',
    created_at: '1643206272851',
    updated_at: '1643206272851',
    description:
      'Find affiliates to promote your affiliate marketing program in minutes.\nThis workflow looks for existing affiliate reviews on Google and finds contact details on autopilot.',
    meta_title: 'Discover affiliate marketers to promote your products or services on autopilot - Hexomatic workflow',
    meta_description:
      '<p>Affiliate marketing is a type of performance-based marketing. Affiliates promote products and services on their websites and social media channels and receive percentage commission if a sale is made.</p>\n\n<p>With Hexomatic you can run an entire affiliate outreach research campaign in minutes - no code or previous experience required.</p>\n\n<p>This workflow taps into Google search to find affiliates that have written content or reviews for any brand.</p>\n\n<p>Hexomatic then performs research on every website to find email addresses and social media profiles you can use to get in touch with affiliates or reviewers to write about your product or service.</p>',
    image:
      'https://storage.googleapis.com/hexomatic-automation-icons/public-workflows-illustrations/Find%20affiliates%20for%20your%20product%20or%20service.jpg',
    categories: [
      {
        id: 2,
        name: 'Marketing',
      },
    ],
    steps: [
      {
        id: 328,
        setting:
          '{"automation_id":30,"dynamic_settings":{"keys":[{"key":null,"settings":{"depth":100,"device":"desktop","radius":"","save_to":100,"latitude":"","longitude":"","save_from":1,"searchType":"organic","uniqueHash":"1651245922902","location_code":2840},"inputValue":"\\"Zoho mail review\\""}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\"}"}',
        index: 0,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 30,
          name: 'Google Search',
          url: 'google-search',
          meta_title: 'Scrape Google Search | Hexomatic',
          meta_description:
            'Perform Google searches and get SERP data instantly via our Google search automation. No proxies or scraping recipes are required.',
          short_description: 'Perform Google searches and get SERP data',
          long_description:
            'Perform Google searches and get results via our managed automation (0.04 premium credit per query to get 100 search results). No proxies or scraping recipes required.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/google-search.png',
        },
      },
      {
        id: 329,
        setting:
          '{"automation_id":6,"dynamic_settings":{"keys":[{"key":"_url","settings":{"proxy":{"type":"","country_code":""},"condition":null,"filter_data":null,"max_results_per_domain":10},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\"}"}',
        index: 1,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 6,
          name: 'Emails scraper',
          url: 'emails-scraper',
          meta_title: 'Email Scraper | Bulk Scrape Emails',
          meta_description:
            'Want to capture emails from any website? The email scraper automation can capture all email addresses found on any web page in minutes.',
          short_description: 'Extract email addresses from any URL',
          long_description: 'Automatically capture all the email addresses published on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/emails-scraper.svg',
        },
      },
      {
        id: 330,
        setting:
          '{"automation_id":7,"dynamic_settings":{"keys":[{"key":"_url","settings":{"media":["_facebook","_youtube","_twitter","_linkedin","_instagram"],"proxy":{"type":"","country_code":""}},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_facebook","_youtube","_twitter","_linkedin","_instagram"],"predefined_settings":{"browser":false},"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\"}"}',
        index: 2,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 7,
          name: 'Social links scraper',
          url: 'social-links-scraper',
          meta_title: 'Social Links Scraper | Hexomatic Automation',
          meta_description:
            'This automation automatically captures all the social media profile links found on a given page and help you get the contact details of potential customers.',
          short_description: 'Extract social media profile links from any URL',
          long_description: 'Automatically capture all the social media profile links found on a page.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/social-links-scraper.svg',
        },
      },
      {
        id: 331,
        setting:
          '{"source":{"source_csv":true,"source_txt":false},"automation_id":74,"dynamic_settings":{"keys":[{"key":"_domain","settings":{"condition":null,"filter_data":null,"max_results_per_domain":10},"inputValue":null}]},"output_keys_data":["_keyword","_url","_rank_group","_rank_absolute","_domain","_title","_cache_url","_breadcrumb","_description","_search_type","_email_scraper","_facebook","_youtube","_twitter","_linkedin","_instagram","_discovered_email"],"predefined_settings":null,"integration_settings":null,"output_keys_data_with_types":"{\\"_url\\":\\"url\\",\\"_rank_group\\":\\"number\\",\\"_rank_absolute\\":\\"number\\",\\"_domain\\":\\"url\\",\\"_title\\":\\"text\\",\\"_cache_url\\":\\"url\\",\\"_breadcrumb\\":\\"url\\",\\"_description\\":\\"text\\",\\"_search_type\\":\\"text\\",\\"_keyword\\":\\"text\\",\\"_email_scraper\\":\\"email address\\",\\"_facebook\\":\\"url\\",\\"_youtube\\":\\"url\\",\\"_snapchat\\":\\"url\\",\\"_twitter\\":\\"url\\",\\"_vkontakte\\":\\"url\\",\\"_telegram\\":\\"url\\",\\"_skype\\":\\"url\\",\\"_linkedin\\":\\"url\\",\\"_angellist\\":\\"url\\",\\"_instagram\\":\\"url\\",\\"_bitbucket\\":\\"url\\",\\"_twitch\\":\\"url\\",\\"_reddit\\":\\"url\\",\\"_flipboard\\":\\"url\\",\\"_steam\\":\\"url\\",\\"_ebay\\":\\"url\\",\\"_vimeo\\":\\"url\\",\\"_soundcloud\\":\\"url\\",\\"_mixcloud\\":\\"url\\",\\"_bandcamp\\":\\"url\\",\\"_flickr\\":\\"url\\",\\"_fotolog\\":\\"url\\",\\"_canva\\":\\"url\\",\\"_disqus\\":\\"url\\",\\"_houzz\\":\\"url\\",\\"_wordpress\\":\\"url\\",\\"_fiverr\\":\\"url\\",\\"_pinterest\\":\\"url\\",\\"_badoo\\":\\"url\\",\\"_medium\\":\\"url\\",\\"_dailymotio\\":\\"url\\",\\"_vine\\":\\"url\\",\\"_quora\\":\\"url\\",\\"_gravatar\\":\\"url\\",\\"_bitly\\":\\"url\\",\\"_behance\\":\\"url\\",\\"_tripadvisor\\":\\"url\\",\\"_dribble\\":\\"url\\",\\"_wattpad\\":\\"url\\",\\"_fanpop\\":\\"url\\",\\"_patreon\\":\\"url\\",\\"_slideshare\\":\\"url\\",\\"_codeacademy\\":\\"url\\",\\"_cybrary\\":\\"url\\",\\"_keybase\\":\\"url\\",\\"_paypal\\":\\"url\\",\\"_instructables\\":\\"url\\",\\"_deviantart\\":\\"url\\",\\"_foursquare\\":\\"url\\",\\"_hubpages\\":\\"url\\",\\"_kongregate\\":\\"url\\",\\"_imgur\\":\\"url\\",\\"_wikipedia\\":\\"url\\",\\"_gamespot\\":\\"url\\",\\"_roblox\\":\\"url\\",\\"_photobucket\\":\\"url\\",\\"_polyvore\\":\\"url\\",\\"_tiktok\\":\\"url\\",\\"_linktree\\":\\"url\\",\\"_linkfolio\\":\\"url\\",\\"_spotify\\":\\"url\\",\\"_campsite\\":\\"url\\",\\"_swipop\\":\\"url\\",\\"_ContactInBio\\":\\"url\\",\\"_discord\\":\\"url\\",\\"_bit.ly\\":\\"url\\",\\"_shor.by\\":\\"url\\",\\"_tap.bio\\":\\"url\\",\\"_about.me\\":\\"url\\",\\"_discovered_email\\":\\"email address\\"}"}',
        index: 3,
        created_at: '1631606440232',
        updated_at: null,
        automation: {
          id: 74,
          name: 'Email discovery',
          url: 'email-discovery',
          meta_title: 'Find Email Address | Email Finder',
          meta_description: 'Find email addresses for any website in minutes to supercharge your cold email outreach.',
          short_description: 'Discover email addresses found on the website or referenced on the internet',
          long_description:
            'Provide a list of domains and discover email addresses found on the website or referenced on the internet.\nThis automation consumes 0.16 premium credits per verified email.',
          has_source: null,
          icon_url: 'https://storage.googleapis.com/hexomatic-automation-icons/email-discovery.svg',
        },
      },
    ],
    tags: ['Marketing'],
  },
];

const points = [
  {
    name: 'Telegram',
    logo: telegram,
    linkTo: '/telegrambot',
  },
  {
    name: 'Slack',
    logo: slack,
    linkTo: '/slackbot',
  },
  {
    name: 'Google',
    logo: google,
    linkTo: '/google',
  },
  {
    name: 'Webhook',
    logo: webhook,
    linkTo: '/webhook',
  },
  {
    name: 'API',
    logo: api,
    linkTo: '/api-documentation',
  },
  // {
  //   name: 'WordPress',
  //   logo: wordpress,
  //   linkTo: '/wordpress',
  // },
  {
    name: 'SQL Database',
    logo: sql,
    linkTo: '/sql-database',
  },
  {
    name: 'Google Drive',
    logo: googleDrive,
    linkTo: '/google-drive',
  },
  {
    name: 'Google Sheets Import',
    logo: googleSheetsImport,
    linkTo: '/google-sheets-import',
  },
  {
    name: 'Google Sheets (Export / Sync)',
    logo: googleSheetsExport,
    linkTo: '/google-sheets-export-sync',
  },
];

const trusted = [
  {
    name: 'GetApp',
    logo: getapp,
    id: 1,
  },
  {
    name: 'Capterra',
    logo: capterra,
    id: 2,
  },
  {
    name: 'GQ',
    logo: gq,
    id: 3,
  },
  {
    name: 'Product hunt',
    logo: hunt,
    id: 4,
  },
];

const Home: FC = () => {
  const isMobile = useMediaQuery({maxWidth: 991});
  const isMobileSm = useMediaQuery({maxWidth: 380});

  const textsImageLeft = [
    {label: 'Wasting time on manual work', top: isMobileSm ? '-2px' : '0px', left: isMobileSm ? '100px' : '120px'},
    {label: 'Copy-pasting all day', top: isMobileSm ? '46px' : '58px', left: isMobileSm ? '56px' : '70px'},
    {label: 'Hiring programmers', top: isMobileSm ? '46px' : '58px', left: isMobileSm ? '186px' : '226px'},
    {label: 'Outsourcing to VA’s', top: isMobileSm ? '94px' : '116px', left: isMobileSm ? '36px' : '42px'},
    {
      label: 'Subscribing to different services',
      top: isMobileSm ? '94px' : '116px',
      left: isMobileSm ? '156px' : '189px',
    },
    {label: 'Procrastinating on tasks', top: isMobileSm ? '142px' : '174px', left: isMobileSm ? '54px' : '66px'},
    {label: 'Complex enterprise tools', top: isMobileSm ? '142px' : '174px', left: isMobileSm ? '194px' : '233px'},
    {label: 'Expensive consultants', top: isMobileSm ? '190px' : '232px', left: isMobileSm ? '110px' : '132px'},
  ];
  const textsImageRight = [
    {label: 'Capture data from any website', top: isMobileSm ? '16px' : '18px', left: isMobileSm ? '60px' : '74px'},
    {label: 'Automate  tedious tasks', top: isMobileSm ? '90px' : '98px', left: isMobileSm ? '60px' : '74px'},
    {label: 'Scale your work on autopilot', top: isMobileSm ? '166px' : '178px', left: isMobileSm ? '60px' : '74px'},
  ];

  return (
    <Layout>
      <div className="pricing_promo_page home-container">
        <Section sectionImage lightBlue className="upper-section" top>
          <Col className="title-section" lg={6}>
            <h1 className="title">
              <div className="primary-color">Web scraping + </div>
              <div className="primary-color">AI work automation,</div>
              <div className="dark-color">made easy</div>
            </h1>
            <div className="d-lg-none d-flex justify-content-center">
              <img
                src={homeMailImgLg}
                srcSet={`${homeMailImgSm} 257w, ${homeMailImgLg} 590w`}
                sizes="(max-width: 585px) 257px, (min-width: 585.98px) 590px"
                alt="Web scraping + work automation"
                className="section-image-iframe"
                style={{maxWidth: '386px'}}
                width={386}
                height={294}
              />
            </div>
            <div className="title-pagehero">
              Tap into the internet as your own data source and automate 100+ sales, marketing, or research tasks on
              autopilot.
            </div>
            <Row className="m-lg-0 upper-section-btn-pos">
              <Col md={7} className="p-2">
                <Button primary className="btn w-100" onClick={() => navigate('/pricing/')}>
                  Get started in minutes
                </Button>
              </Col>
              <Col md={4} className="p-2">
                <Button className="btn demo-request-btn w-100" onClick={openCalendly} outline>
                  Demo request
                </Button>
              </Col>
            </Row>
          </Col>
          <Col className="d-lg-flex d-none justify-content-end" lg={6}>
            <div>
              <img
                src={homeMailImgLg}
                srcSet={`${homeMailImgSm} 257w, ${homeMailImgLg} 555w`}
                sizes="(max-width: 585px) 257px, (min-width: 585.98px) 555px"
                alt="Web scraping + work automation"
                className="section-image-iframe"
                width={555}
                height={420}
              />
            </div>
          </Col>
        </Section>
        <Section className="py-40">
          <Col>
            <div className="section-part">
              <h2 className="title">
                <p className="concept-title">SKYROCKET YOUR PRODUCTIVITY</p>
                Your <span className="primary-color">virtual assistant</span>
                <br />
                that never sleeps
              </h2>

              <div className="row w-100" style={{maxWidth: '1000px'}}>
                <div className="col-12 col-lg-5 p-0">
                  <div className="mb-4">
                    <div className="concept-title">THE OLD WAY</div>
                    <div className="concept-title-dark">Drowning in tasks</div>
                  </div>

                  <div className="position-relative" style={{maxWidth: isMobileSm ? '300px' : '360px', margin: 'auto'}}>
                    <img
                      src={left}
                      alt="Drowning in tasks"
                      className="justify-content-center image-styles"
                      style={{
                        maxWidth: isMobileSm ? '300px' : '360px',
                        margin: 'auto',
                        width: isMobileSm ? '300px' : '100%',
                      }}
                      width={isMobileSm ? 300 : 360}
                      height={290}
                    />
                    {textsImageLeft.map(item => (
                      <div
                        style={{
                          position: 'absolute',
                          top: item.top,
                          left: item.left,
                          fontSize: isMobileSm ? '7px' : '8.7px',
                          color: '#516077',
                          fontWeight: 500,
                        }}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-12 col-lg-2 d-flex p-0">
                  <div className="vs-line-main mx-auto mt-auto"></div>
                </div>

                <div className="col-12 col-lg-5 p-0">
                  <div className="mb-4">
                    <div className="concept-title">THE NEW WAY</div>
                    <div className="concept-title-dark">10X your productivity</div>
                  </div>
                  <div className="position-relative" style={{maxWidth: isMobileSm ? '300px' : '320px', margin: 'auto'}}>
                    <img
                      src={right}
                      alt="10X your productivity"
                      className="justify-content-center image-styles"
                      style={{maxWidth: '320px', margin: 'auto', width: isMobileSm ? '300px' : '100%'}}
                      width={isMobileSm ? 300 : 320}
                      height={260}
                    />
                    {textsImageRight.map(item => (
                      <div
                        style={{
                          position: 'absolute',
                          top: item.top,
                          left: item.left,
                          fontSize: isMobileSm ? '12px' : '14px',
                          color: '#050038',
                          fontWeight: 500,
                        }}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Section>
        <TrustedSection />
        <Section smVioletLgLight className="pt-5 pb-4 px-3">
          <div className="section-part m-auto">
            <p className="concept-title-scrape">NO-CODE WEB SCRAPING</p>
            <h2 className="title-scrape">
              Turn any website into <span className="primary-color-scrape">a spreadsheet</span>
            </h2>
            <p className="title-pagehero-scrape pt-2 w-md-75">
              Tap into our 1-click web scraper for the most popular websites, or create your own web scraping recipes to
              extract products, content, media, or leads from most websites. No code required.
            </p>
            <img
              src={ScrapeSm}
              width={370}
              height={596}
              alt="Web scraping"
              className="d-flex d-md-none image-styles"
              style={{maxWidth: '370px'}}
            />
          </div>
          <div className="section-part d-none d-md-flex m-auto">
            <img
              src={ScrapeLg}
              alt="Web scraping"
              className="image-styles"
              style={{maxWidth: '1070px'}}
              width={1070}
              height={401}
            />
          </div>
        </Section>
        <Section lightBlue className="py-40 px-3">
          <Col className="section-part">
            <p className="concept-title">AUTOMATE WORK TASKS</p>
            <h2 className="title mb-1">
              Automations to perform
              <br /> <span className="primary-color">tasks on autopilot </span>
            </h2>
            <p className="title-pagehero pt-2 w-md-75">
              Get access to 100+ ready-made automations to perform work tasks on your data, including capturing contact
              details, validating email addresses, or performing AI tasks scale.
            </p>
            <div className="automation-cards row">
              {automations.map(item => {
                return (
                  <Col md={6} lg={4} key={item.id} className="px-2 py-2">
                    <Link to={`/automation/${cleanURL(item.url)}`}>
                      <AutomationCards
                        title={item.name}
                        description={item.short_description}
                        icon={item.icon_url}
                        is_new={item.is_new}
                        rate={4.1}
                        active={true}
                        //@ts-ignore
                        credit_price={item.credit_price}
                        //@ts-ignore
                        premium_credit_price={item.premium_credit_price}
                        type={item.type}
                      />
                    </Link>
                  </Col>
                );
              })}
            </div>
            <Button onClick={() => navigate('/automations/')} className="mt-4">
              Show all automations {arrowRightIcon}
            </Button>
          </Col>
        </Section>
        <Section lightBlue className="py-40 px-3">
          <Col className="section-part">
            <p className="concept-title">WORKFLOWS</p>
            <h2 className="title">
              You are just one workflow away from
              <br /> saving&nbsp;
              <span className="primary-color">100+ hours a month </span>
            </h2>
            <p className="title-pagehero pt-2 w-md-75">
              Combine your own scraping recipes and our ready made automations to create powerful workflows you can run
              on autopilot.
            </p>
            <div className="row">
              {workflows.map(item => (
                <WorkflowCard data={item} />
              ))}
            </div>
            <Button onClick={() => navigate('/ready-made-workflow-library/')} className="mt-4">
              Show all workflows {arrowRightIcon}
            </Button>
          </Col>
        </Section>
        <Section className="pt-5 px-3" dark>
          <Col className="section-part">
            <h2 className="primary-color text-center mb-0">
              Trusted by 130,000+
              <span className="trusted-title">
                &nbsp;forward <br />
                thinking businesses
              </span>
              <img
                src={TrustedBusinesses}
                alt="Trusted by 130,000+ businesses"
                className="mt-4 trusted-img d-none d-md-flex"
                width={1022}
                height={694}
                style={{maxWidth: '1022px', width: '100%', height: 'auto'}}
              />
            </h2>
            <div className="d-md-none d-flex ">
              <Carousel />
            </div>
          </Col>
        </Section>
        <Section lightBlue className="py-40 px-3">
          <Col className="section-part">
            <p className="concept-title">AI MOVEMENT</p>
            <h2 className="title">
              Perform AI tasks <span className="primary-color">at scale</span>
            </h2>
            <p className="title-pagehero">
              Featuring native ChatGPT and Google Gemini automations, you can now automate human tasks such as writing,
              summarization, and analysis right inside your workflow.{' '}
            </p>
            <p className="title-pagehero" style={{fontWeight: 600}}>
              Say goodbye to manual, time-consuming tasks and embrace the future of automation.
            </p>
            <div className="row">
              <Col lg={6} className="d-none d-lg-flex">
                <img
                  src={ai1}
                  className="image-styles my-auto"
                  alt="Web scraping meets AI"
                  width={515}
                  height={350}
                  style={{maxWidth: '515px', marginLeft: '-30px'}}
                />
              </Col>
              <Col lg={6} className="align-self-center pr-lg-5">
                <h2 className="title text-lg-left">
                  Web Scraping <span className="primary-color">meets AI</span>
                </h2>
                <img
                  src={ai1}
                  className="d-lg-none d-flex image-styles"
                  alt="Web scraping meets AI"
                  width={515}
                  height={350}
                  style={{maxWidth: '515px', margin: 'auto'}}
                />
                <p className="title-pagehero text-lg-left">
                  This takes web scraping software to the next level, as you can now not only extract data from the most
                  complex websites but also perform human tasks on the data collected. No need for any coding skills or
                  expensive enterprise software.
                </p>
                <p className="title-pagehero text-lg-left">
                  Hexomatic makes it easy to web scrape entire eCommerce websites as well as search engines with full
                  support for pagination whilst improving or rewriting product listings and articles at scale using AI.
                </p>
              </Col>
            </div>
            <div className="row mt-5 mt-lg-0">
              <Col lg={6} className="align-self-center pr-lg-5">
                <h2 className="title text-lg-left">
                  A new world of <span className="primary-color">possibilities</span>
                </h2>
                <img
                  src={ai2}
                  className="d-flex d-lg-none image-styles"
                  alt="A new world of possibilities"
                  width={515}
                  height={350}
                  style={{maxWidth: '515px', margin: 'auto'}}
                />
                <p className="title-pagehero text-lg-left">
                  Alternatively, you can upload your own data to perform common ChatGPT AI tasks such as summarization,
                  content writing, optimization, analysis, or classification in bulk with just a few clicks.
                </p>
                <p className="title-pagehero text-lg-left">
                  By combining super simple point-and-click web scraping with generative AI, Hexomatic opens up a world
                  of possibilities for scaling your business in the cloud with one tool. Unlock the true potential of AI
                  automation with Hexomatic and leave manual tasks behind. 
                </p>
              </Col>
              <Col lg={6} className="d-none d-lg-flex">
                <img
                  src={ai2}
                  className="image-styles my-auto"
                  alt="A new world of possibilities"
                  width={515}
                  height={350}
                  style={{maxWidth: '515px', marginLeft: '-20px'}}
                />
              </Col>
            </div>
          </Col>
        </Section>
        <Section className="py-40 px-3">
          <Col className="section-part">
            <p className="concept-title">INTEGRATIONS</p>
            <h2 className="title">Software Integrations</h2>
            <p className="title-pagehero">Your team’s favourite tools are just a click away.</p>
            <div className="row d-flex justify-content-center" style={{maxWidth: '900px', margin: 'auto'}}>
              {points.map(item => {
                return (
                  <div key={item.name} className="d-flex justify-content-center align-items-center">
                    <div className="m-2">
                      {item.linkTo ? (
                        <Link to={item.linkTo || ''}>
                          <img
                            src={item.logo}
                            alt={item.name}
                            width="80px"
                            height="80px"
                            className="integration-card-image"
                          />
                        </Link>
                      ) : (
                        <>
                          <img src={item.logo} alt={item.name} width="80px" height="80px" />
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Section>

        <Section lightBlue className="py-40 px-3">
          <DemoCta />
        </Section>
      </div>
    </Layout>
  );
};

export default Home;
